import { render, staticRenderFns } from "./MainActivity.vue?vue&type=template&id=7fe86c4c&scoped=true&lang=pug"
import script from "./MainActivity.vue?vue&type=script&lang=js"
export * from "./MainActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe86c4c",
  null
  
)

export default component.exports